import { defineComponent } from "vue";
import { mapState } from "pinia";
import useVuelidate from "@vuelidate/core";
import { helpers, maxLength, required, requiredIf } from "@vuelidate/validators";

import {
    formatDateInput,
    formatDate,
    formatZipCode
} from "../../../../../../../common/vue-helpers/modifiers/value-modifier";
import { useHospiceConvertToPending } from "../../../../store/useHospiceConvertToPending";

import PlacesAutocomplete from "../../../../../../../resources-vue/vue-custom-elements/PlacesAutocomplete/PlacesAutocomplete.vue";
import StateTypeahead from "../../../../../../../resources-vue/vue-custom-elements/StateTypeahead/StateTypeahead.vue";
import PhoneNumber from "../../../../../../../resources-vue/vue-custom-elements/PhoneNumber/PhoneNumber.vue";
import EmptyTextHandler from "../../../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";
import DatePicker from "../../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";

export default defineComponent({
    components: {
        PlacesAutocomplete,
        StateTypeahead,
        PhoneNumber,
        EmptyTextHandler,
        DatePicker
    },

    props: {
        benefitPeriodStartDate: {
            type: String
        },
        benefitPeriodEndDate: {
            type: String
        },
        homePhoneNumberOptions: {
            type: Array
        },
        isReadOnly: {
            type: Boolean
        },
        handleDateChange: {
            type: Function
        }
    },
    data() {
        return {
            formatDate,
            formatDateInput,
            formatZipCode,
            v$: useVuelidate()
        };
    },

    validations() {
        return {
            patientDetails: {
                priorHospice: {
                    name: {
                        required: requiredIf(() => {
                            return this.patientDetails.isTransfer;
                        })
                    },
                    benefitPeriodStartDate: {
                        required: requiredIf(() => {
                            return this.patientDetails.isTransfer;
                        })
                    }
                },
                benefitPeriodNumber: {
                    required: helpers.withMessage(
                        "Benefit Period Number is requried.",
                        requiredIf(() => {
                            return this.patientDetails.isTransfer;
                        })
                    ),
                    maxLength: helpers.withMessage("Benefit Period Number is invalid.", maxLength(2))
                }
            }
        };
    },

    computed: {
        ...mapState(useHospiceConvertToPending, ["patientDetails", "application"])
    },
    methods: {
        handleFaceToFace() {
            this.patientDetails.priorHospice.faceToFaceObtained = !this.patientDetails.priorHospice.faceToFaceObtained;
        },
        handleDate(date: any, name: any) {
            if (name === "admissionDate") {
                this.patientDetails.priorHospice.admissionDate = date;
            }
            if (name === "transferDate") {
                this.patientDetails.priorHospice.transferDate = date;
            }
        },
        updateSelectedState(value: any) {
            this.patientDetails.priorHospice.transferHospiceAddress.primaryState = value;
        },
        updateprefillState(value: any) {
            this.patientDetails.priorHospice.transferHospiceAddress.state = value;
        },
        handleDateInputChange(e: any) {
            const name = e.target.name;
            const value = e.target.value;
            this.handleDate(value, name);
        }
    }
});
